import { DataManager } from "../model/DataManager.js";
import { VOHomeCategory } from "../model/DataStructure.js";
import { Home } from "./Home.js";

export class Minimap {
    public onRequestHomeCategory = e5.Signal.create<[VOHomeCategory]>();
    public element: HTMLDivElement;

    private _viewport: HTMLDivElement;
    private _viewportCanvas: HTMLCanvasElement;
    private _backgroundCanvas: HTMLCanvasElement;
    private _labels: Label[] = [];
    private _labelContainer: HTMLDivElement;
    private _currentLabel: Label = null;

    constructor(
        private _data: DataManager,
        private _home: Home,
        private _image: HTMLImageElement,
        private _screenWidth: number) {

        this.element = document.createElement("div");
        this.element.id = "minimap";
        this.element.classList.add("active");

        this.createBackground();
        this.createViewport();

        this.element.style.width = this._backgroundCanvas.width + "px";
        this.element.style.height = this._backgroundCanvas.height + "px";

        var labelContainer = document.createElement("div");
        labelContainer.className = "labels";
        this._labelContainer = labelContainer;
        this._viewport.appendChild(labelContainer);

        var home = this._home.home;
        for (var homeCategory of home.categories) {
            var label = new Label(homeCategory, this._backgroundCanvas.width / home.categories.length);
            label.onClick.add(this.handleClickLabel, this);
            labelContainer.appendChild(label.element);
            this._labels.push(label);
        }

        this._home.onChangeX.add((x) => this.setX(x));

        this._backgroundCanvas.addEventListener("click", (e) => {
            var local = e5.Transform.toLocal(this._backgroundCanvas, e.clientX, e.clientY);
            var x = local.x * (this._image.width / this._backgroundCanvas.width);
            var c = this._home.getHomeCategoryByPosition(-(x - this._screenWidth * 0.5));
            if (c)
                this.onRequestHomeCategory.dispatch(c);
        });
    }

    public get active(): boolean {
        return this.element.classList.contains("active");
    }

    public set active(active: boolean) {
        this.element.classList.toggle("active", active);
    }

    private handleClickLabel(label: Label): void {
        this._home.openOrTweenToHomeCategory(label.homeCategory);
    }

    // private toBackground(x: number, y: number): e5.IPoint {
    //     var ratio = (x - 1920 * 0.5) / (this._image.width - this._screenWidth);
    //     var scale = (this._viewportCanvas.width / this._image.width);
    //     var width = this._screenWidth * scale;
    //     var xPos = ratio * (this._backgroundCanvas.width - width);
    //     xPos += width * 0.5;

    //     var scale = this._backgroundCanvas.width / this._image.width;
    //     return {
    //         x: xPos,
    //         y: y * scale
    //     }
    // }

    private createBackground(): void {
        this._backgroundCanvas = this.createCanvas(50);
        this._backgroundCanvas.className = "background";
        this.element.appendChild(this._backgroundCanvas);

        var context = this._backgroundCanvas.getContext("2d");
        var img = this._backgroundCanvas;
        context.globalCompositeOperation = "destination-out";

        var gradient = context.createLinearGradient(0, 0, img.width, 0);
        gradient.addColorStop(0, "rgba(255, 255, 255, 1.0)");
        gradient.addColorStop(0.5, "rgba(255, 255, 255, 0)");
        gradient.addColorStop(1, "rgba(255, 255, 255, 1.0)");

        // var gradient = context.createRadialGradient(img.width * 0.5, img.height * 0.5, 0, img.width * 0.5, img.height * 0.5, img.width * 0.5);
        // gradient.addColorStop(0, "rgba(255, 255, 255, 0)");
        // gradient.addColorStop(1, "rgba(255, 255, 255, 1.0)");

        context.fillStyle = gradient;
        context.fillRect(0, 0, img.width, img.height);
    }

    private createViewport(): void {
        this._viewportCanvas = this.createCanvas(this._backgroundCanvas.height + 20);
        this._viewport = document.createElement("div");
        this._viewport.className = "viewport";
        this._viewport.innerHTML = `<div class="icon icon-49"></div>`;
        this._viewport.style.backgroundImage = `url(${this._viewportCanvas.toDataURL()})`;

        var scale = (this._viewportCanvas.width / this._image.width);
        var width = this._screenWidth * scale;
        var height = this._image.height * scale;
        this._viewport.style.width = width + "px";
        this._viewport.style.height = height + "px";
        this._viewport.style.top = -(this._viewportCanvas.height - this._backgroundCanvas.height) * 0.5 + "px";
        this.element.appendChild(this._viewport);
    }

    private setX(x: number): void {
        var ratio = (-x) / (this._image.width - this._screenWidth);
        var scale = (this._viewportCanvas.width / this._image.width);
        var width = this._screenWidth * scale;
        var xPos = ratio * (this._backgroundCanvas.width - width);
        this._viewport.style.transform = `translateX(${xPos}px)`;
        this._viewport.style.backgroundPositionX = -ratio * (this._viewportCanvas.width - width) + "px";

        var ca = this._home.getCurrentHomeCategory();
        if (ca) {
            this._viewport.setAttribute("data-homecategory", ca.id + "");
        }

        this.currentLabel = this.getLabelByCategory(ca);
    }

    private get currentLabel(): Label {
        return this._currentLabel;
    }

    private set currentLabel(label: Label) {
        if (this._currentLabel === label)
            return;

        if (this._currentLabel) {
            this._currentLabel.element.classList.remove("active");
        }
        this._currentLabel = label;
        if (this._currentLabel) {
            this._currentLabel.element.classList.add("active");

            var labelX = -(label.element.offsetLeft + label.element.offsetWidth * 0.5);
            labelX += this._viewport.offsetWidth * 0.5;
            this._labelContainer.style.transform = `translateX(${labelX}px)`;
        }
    }

    private getLabelByCategory(category: VOHomeCategory): Label {
        for (var label of this._labels) {
            if (label.homeCategory === category)
                return label;
        }
        return null;
    }

    private createCanvas(height: number): HTMLCanvasElement {
        var scale = height / this._image.height;
        var width = scale * this._image.width;

        var can = document.createElement("canvas");
        can.width = width;
        can.height = height;

        var ctx = can.getContext("2d");
        ctx.drawImage(this._image, 0, 0, width, height);
        return can;
    }
}

class Label {
    public onClick = e5.Signal.create<[Label]>();

    public element: HTMLDivElement;

    constructor(
        public homeCategory: VOHomeCategory, width: number) {

        this.element = document.createElement("div");
        this.element.className = "label";
        this.element.innerHTML = `
            <span class="title-placeholder">${homeCategory.home_category.title}</span>
            <span class="title">${homeCategory.home_category.title}</span>
            <span class="open">Tap To Open</span>`;
        this.element.style.width = width + "px";

        this.element.addEventListener("click", (e) => {
            e.stopImmediatePropagation();
            this.onClick.dispatch(this);
        });
    }
}